import type { Resource } from '../../';
export const country_countries_IE: Resource = {"default":"Ireland"};
